import { render, staticRenderFns } from "./ActividadesCostos.vue?vue&type=template&id=776b06f2&scoped=true"
import script from "./ActividadesCostos.vue?vue&type=script&lang=js"
export * from "./ActividadesCostos.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ActividadesCostos.vue?vue&type=style&index=1&id=776b06f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b06f2",
  null
  
)

export default component.exports